import { lazy } from "react";

// Lazy load pages for better performance
const Login = lazy(() => import("../pages/auth/Login"));
const Signup = lazy(() => import("../pages/auth/Signup"));
const VerifyOTP = lazy(() => import("../pages/auth/VerifyOTP"));
const Chat = lazy(() => import("../pages/chat/Chat"));
const Profile = lazy(() => import("../pages/chat/Profile"));
const Settings = lazy(() => import("../pages/chat/Settings"));
const SyncHistory = lazy(() => import("../pages/chat/SyncHistory"));
const NotFound = lazy(() => import("../pages/public/NotFound"));
const VerifyEmail = lazy(() => import("../pages/auth/VerifyEmail"));

// Route configuration
export const routes = [
  // Public routes (no authentication required)
  {
    path: "/",
    element: Chat,
    public: false,
    title: "Chat",
  },
  {
    path: "/login",
    element: VerifyEmail,
    public: true,
    title: "Login",
  },
  {
    path: "/signup",
    element: Signup,
    public: true,
    title: "Sign Up",
  },
  {
    path: "/verify-otp",
    element: VerifyOTP,
    public: true,
    title: "Verify OTP",
  },
  {
    path: "/verify-email",
    element: VerifyEmail,
    public: true,
    title: "Verify Email",
  },

  // Protected routes (authentication required)
  {
    path: "/profile",
    element: Profile,
    public: false,
    title: "Profile",
  },
  {
    path: "/settings",
    element: Settings,
    public: false,
    title: "Settings",
  },
  {
    path: "/sync-history",
    element: SyncHistory,
    public: false,
    title: "Sync History",
  },

  // 404 route
  {
    path: "*",
    element: NotFound,
    public: false,
    title: "Not Found",
  },
];

// Helper function to check if user has access to a route
export const hasAccess = (route, isAuthenticated) => {
  if (route.public) {
    return true;
  }
  return isAuthenticated;
};

// Helper function to get route by path
export const getRouteByPath = (path) => {
  return routes.find((route) => route.path === path);
};

// Helper function to get all public routes
export const getPublicRoutes = () => {
  return routes.filter((route) => route.public);
};

// Helper function to get all protected routes
export const getProtectedRoutes = () => {
  return routes.filter((route) => !route.public);
};

// Helper function to get route title by path
export const getRouteTitle = (path) => {
  const route = getRouteByPath(path);
  return route ? route.title : "Unknown";
};

export default routes;
